<template>
  <div class="view">
    <div class="content">
      <h2 class="ui inverted header">Sign up</h2>
      <div class="socials" v-if="!invitationId">
        <a class="ui large label" @click="thirdPartyLogin('github')"><i class="github icon" />Github</a>
        <a class="ui large label" @click="thirdPartyLogin('bitbucket')"><i class="bitbucket icon" />Bitbucket</a>
        <a class="ui large label" @click="thirdPartyLogin('google')"><i class="google icon" />Google</a>
        <a class="ui large label" @click="thirdPartyLogin('facebook')"><i class="facebook icon" />Facebook</a>
      </div>
      <sui-segment :loading="loading">
        <sui-form :error="hasError" @submit.prevent="submit">
          <sui-form-field>
            <sui-input type="text" ref="email" v-model.trim="email" :readonly="isEmailDisabled" :disabled="isEmailDisabled" placeholder="Email" icon="user" icon-position="left" autocomplete="email" required />
          </sui-form-field>
          <sui-form-field>
            <sui-input type="password" ref="password" v-model.trim="password" placeholder="Password" icon="lock" icon-position="left" autocomplete="new-password" required />
          </sui-form-field>
          <sui-button size="large" color="green" fluid>Sign up<span v-show="invitationId"> and join</span></sui-button>
          <sui-message error>
            {{error}}
          </sui-message>
        </sui-form>
      </sui-segment>
      <sui-message v-if="!invitationId">
        Already registered? <router-link :to="{path: '/user/login', query: {email}}" data-goal="USER_SIGNIN_OPEN">Log in</router-link>
      </sui-message>
      <small>© D2C, 2017-2020. All rights reserved.</small>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import utils from '@/utils'

  export default {
    name: 'AccountRegister',
    data() {
      return {
        email: '',
        password: '',
        invitationId: null,
        loading: false,
        isEmailDisabled: false,
        error: null,
      }
    },
    computed: {
      hasError() {
        return Boolean(this.error)
      },
    },
    methods: {
      submit() {
        this.register()
      },
      register() {
        const GOAL = this.invitationId ? 'JOIN' : 'SIGNUP'
        this.loading = true
        this.error = null
        utils.reachGoal(`USER_${GOAL}_TRY`)
        api.register(this.email, this.password, this.invitationId).then(() => {
          utils.reachGoal(`USER_${GOAL}_SUCCESS`)
          if (this.invitationId) {
            this.login()
          } else {
            this.$router.push('/user/registerStart')
          }
        }).catch(error => {
          utils.reachGoal(`USER_${GOAL}_FAIL`)
          this.error = error
        }).finally(() => {
          this.loading = false
        })
      },
      login() {
        api.login(this.email, this.password).then(data => {
          this.$store.dispatch('login', data.member.token)
        })
      },
      thirdPartyLogin(method) {
        utils.reachGoal(`USER_SIGNUP_${method.toUpperCase()}`)
        api.thirdPartyLogin(method)
      },
    },
    mounted() {
      this.email = this.$route.query.email
      this.invitationId = this.$route.query.invitationId
      this.isEmailDisabled = Boolean(this.email && this.invitationId)
      this.$nextTick(() => {
        if (this.email) {
          this.$refs.password.$refs.input.focus()
        } else {
          this.$refs.email.$refs.input.focus()
        }
      })
    },
  }
</script>

<style scoped>
  .view { display: flex; align-items: center; justify-content: center; text-align: center; }
  .content { min-width: 300px; }
  .socials { display: flex; }
  small { color: #eee; }
</style>
